import { NgModule } from "@angular/core";
import { LhHeaderComponent } from "./components/lh-header/lh-header.component";
import { LhCommonsModule } from "../lh-commons/lh-commons.module";
import { LhLandingPageComponent } from "./landing-page/landing-page.component";
import { LhFooterComponent } from "./components/lh-footer/lh.footer.component";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

@NgModule({
    declarations: [
        LhHeaderComponent,
        LhFooterComponent,
        LhLandingPageComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        LhCommonsModule
    ],
    exports: [
        LhHeaderComponent,
        LhFooterComponent,
        LhLandingPageComponent
    ],
    providers: [ ]
})
export class LhCoreModule { }